import { Outlet } from "react-router-dom";
import { ClerkList, clerksListLoader } from "./point-of-sale/clerk-report";
import { FinancialReport, financialReportLoader } from "./point-of-sale/financial-report";
import { EventReport, eventReportLoader } from "./point-of-sale/event-report";
import { CashBalanceReport, cashBalanceReportLoader } from "./point-of-sale/cash-balance-report";
import { locationSalesLoader, LocationSalesReport } from "./point-of-sale/location-sales-report";
import { vendorSalesLoader, VendorSalesReport } from "./point-of-sale/vendor-sales-report";
import { vendorTypeSalesLoader, VendorTypeSalesReport } from "./point-of-sale/vendor-type-sales-report";
import { ProductMixReport } from "./point-of-sale/product-mix-report";
import { ProductMixUpdated } from "./point-of-sale/product-mix-updated";
import { productMixSummaryLoader, ProductMixSummaryReport } from "./point-of-sale/product-mix-summary-report";
import { TransactionsReport} from "./point-of-sale/transactions-report";
import { requireAuth, requireRoninAdmin } from "../auth/RequireAuth";
import { Breadcrumb } from "../../components/Breadcrumb";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { PromoBalanceReport, promoBalanceReportLoader } from "./point-of-sale/promo-balance-report";
import {
  FinancialCumulativeHourlyReport,
  financialCumulativeHourlyLoader,
} from "./point-of-sale/financial-cumulative-hourly-report";
import {
  FinancialHourlyReport,
  financialHourlyLoader,
} from "./point-of-sale/financial-hourly-report";
import {DeferredReport, deferredTransactionsLoader} from "./point-of-sale/deferred-report";
import {AccessScansReport} from "./access/access-scans-report";
import {DiscountsReport, discountsReportLoader} from "./point-of-sale/discounts-report";
import {WebCheckoutReport} from "./web-checkout/web-checkout-report";
import {glAccountLoader, GLAccountReport} from "./point-of-sale/gl-account-report";
import {PromoCodesReport, promoCodesReportLoader} from "./point-of-sale/promo-codes-report";
import {FinancialReportTicketing, financialReportTicketingLoader} from "./ticketing/financial-report-ticketing";
import {itemReportTicketingLoader, ItemTicketingReport} from "./ticketing/item-report-ticketing";
import {eventReportTicketingLoader, EventTicketingReport} from "./ticketing/event-report-ticketing";
import {
  financialCumulativeHourlyTicketingLoader,
  FinancialCumulativeHourlyTicketingReport
} from "./ticketing/financial-cumulative-hourly-report-ticketing";
import {
  financialHourlyTicketingLoader,
  FinancialHourlyTicketingReport
} from "./ticketing/financial-hourly-report-ticketing";
import {promoCodesReportTicketingLoader, PromoCodesTicketingReport} from "./ticketing/promo-codes-report-ticketing";
import {TransactionsTicketingReport} from "./ticketing/transactions-report-ticketing";
import {TabManagementReport} from "./point-of-sale/tab-management-report";
import {OrderItemsReport} from "./point-of-sale/order-items-report";
import {SubEventReport, subEventReportLoader} from "./point-of-sale/sub-event-report";
import {EventSummaryReport} from "./point-of-sale/event-summary-report";
import {VerticalSalesReport} from "./point-of-sale/vertical-sales-report";
import {VendorPayouts} from "./point-of-sale/vendor-payouts";
import {CommissaryReport} from "./point-of-sale/commissary-report";
import {MXMerchantReconciliation} from "./point-of-sale/mx-reconciliation";
import {AttendeeDemographicsReport} from "./point-of-sale/attendee-demographics-report";
import {PERMISSIONS} from "../auth/api";
import {AdminAppUsageReport} from "./admin-app-usage";

const ReportsIndex = () => {
  return (
    <div className="min-h-screen">
      <div className="my-4">
      </div>
      <Outlet />
    </div>
  );
};

export const reportsRouter = {
  path: "/reports",
  id: "reports",
  element: <ReportsIndex />,
  loader: requireAuth(),
  children: [
    {
      path: "clerk-report",
      id: "clerk-report",
      loader: clerksListLoader,
      errorElement: <ErrorBoundary />,
      element: <ClerkList />,
      handle: {
        crumb: () => (
          <Breadcrumb name="Clerk Report" href="/reports/clerk-report" />
        ),
      },
    },
    {
      path: "transaction-report",
      id: "transaction-report",
      element: <TransactionsReport />,
      // loader: transactionsLoader,
      handle: {
        crumb: () => (
          <Breadcrumb name="Transactions Report" href="/reports/transaction-report" />
        ),
      },
    },
    {
      path: "order-items-report",
      id: "order-items-report",
      element: <OrderItemsReport />,
      handle: {
        crumb: () => (
          <Breadcrumb name="Order Items Report" href="/reports/order-items-report" />
        ),
      },
    },
    {
      path: "tab-management-report",
      id: "tab-management-report",
      element: <TabManagementReport />,
      handle: {
        crumb: () => (
          <Breadcrumb name="Tab Management Report" href="/reports/tab-management-report" />
        ),
      },
    },
    {
      path: "transaction-report-ticketing",
      id: "transaction-report-ticketing",
      element: <TransactionsTicketingReport />,
      // loader: transactionsLoader,
      handle: {
        crumb: () => (
            <Breadcrumb name="Transactions Report" href="/reports/transaction-report-ticketing" />
        ),
      },
    },
    {
      path: "access-scans-report",
      id: "access-scans-report",
      element: <AccessScansReport />,
      // loader: transactionsLoader,
      handle: {
        crumb: () => (
            <Breadcrumb name="Access Scans Report" href="/reports/access-scans-report" />
        ),
      },
    },
    {
      path: "deferred-transaction-report",
      id: "deferred-transaction-report",
      element: <DeferredReport />,
      loader: deferredTransactionsLoader,
      handle: {
        crumb: () => (
            <Breadcrumb name="Deferred Transactions Report" href="/reports/deferred-transaction-report" />
        ),
      },
    },
    {
      path: "discounts-report",
      id: "discounts-report",
      element: <DiscountsReport />,
      loader: discountsReportLoader,
      handle: {
        crumb: () => (
            <Breadcrumb name="Discounts Report" href="/reports/discounts-report" />
        ),
      },
    },
    {
      path: "promo-codes-report",
      id: "promo-codes-report",
      element: <PromoCodesReport />,
      loader: promoCodesReportLoader,
      handle: {
        crumb: () => (
            <Breadcrumb name="Promo Codes Report" href="/reports/promo-codes-report" />
        ),
      },
    },
    {
      path: "promo-codes-report-ticketing",
      id: "promo-codes-report-ticketing",
      element: <PromoCodesTicketingReport />,
      loader: promoCodesReportTicketingLoader,
      handle: {
        crumb: () => (
            <Breadcrumb name="Ticketing Promo Codes Report" href="/reports/promo-codes-report-ticketing" />
        ),
      },
    },
    {
      path: "financial-report",
      id: "financial-report",
      element: <FinancialReport />,
      loader: financialReportLoader,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Financial Report"
            href="/reports/financial-report"
          />
        ),
      },
    },
    {
      path: "financial-report-ticketing",
      id: "financial-report-ticketing",
      element: <FinancialReportTicketing />,
      loader: financialReportTicketingLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Financial Report"
                href="/reports/financial-report-ticketing"
            />
        ),
      },
    },
    {
      path: "cumulative-net-hourly-report",
      id: "cumulative-net-hourly-report",
      element: <FinancialCumulativeHourlyReport />,
      loader: financialCumulativeHourlyLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Net Cumulative Hourly Sales Report"
                href="/reports/cumulative-net-hourly-report"
            />
        ),
      },
    },
    {
      path: "net-hourly-report",
      id: "net-hourly-report",
      element: <FinancialHourlyReport />,
      loader: financialHourlyLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Net Hourly Sales Report"
                href="/reports/net-hourly-report"
            />
        ),
      },
    },
    {
      path: "cumulative-net-hourly-report-ticketing",
      id: "cumulative-net-hourly-report-ticketing",
      element: <FinancialCumulativeHourlyTicketingReport />,
      loader: financialCumulativeHourlyTicketingLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Ticketing Net Cumulative Hourly Sales Report"
                href="/reports/cumulative-net-hourly-report-ticketing"
            />
        ),
      },
    },
    {
      path: "net-hourly-report-ticketing",
      id: "net-hourly-report-ticketing",
      element: <FinancialHourlyTicketingReport />,
      loader: financialHourlyTicketingLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Ticketing Net Hourly Sales Report"
                href="/reports/net-hourly-report-ticketing"
            />
        ),
      },
    },
    {
      path: "event-report",
      id: "event-report",
      element: <EventReport />,
      loader: eventReportLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Event Sales Report"
                href="/reports/event-report"
            />
        ),
      },
    },
    {
      path: "sub-event-report",
      id: "sub-event-report",
      element: <SubEventReport />,
      loader: subEventReportLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Sub-Event Sales Report"
                href="/reports/sub-event-report"
            />
        ),
      },
    },
    {
      path: "event-report-ticketing",
      id: "event-report-ticketing",
      element: <EventTicketingReport />,
      loader: eventReportTicketingLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Ticketing Event Sales Report"
                href="/reports/event-report-ticketing"
            />
        ),
      },
    },
    {
      path: "location-report",
      id: "location-report",
      element: <LocationSalesReport />,
      loader: locationSalesLoader,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Location Sales Report"
            href="/reports/location-report"
          />
        ),
      },
    },
    {
      path: "product-mix-report",
      id: "product-mix-report",
      element: <ProductMixReport />,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Product Mix Report"
            href="/reports/product-mix-report"
          />
        ),
      },
    },
    {
      path: "product-mix-updated",
      id: "product-mix-updated",
      element: <ProductMixUpdated />,
      loader: requireAuth([PERMISSIONS.ADMIN]),
      errorElement: <ErrorBoundary />,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Product Mix (Updated)"
            href="/reports/product-mix-updated"
          />
        ),
      },
    },
    {
      path: "item-report-ticketing",
      id: "item-report-ticketing",
      element: <ItemTicketingReport />,
      loader: itemReportTicketingLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Ticketing Item Report"
                href="/reports/item-report-ticketing"
            />
        ),
      },
    },
    {
      path: "product-mix-summary-report",
      id: "product-mix-summary-report",
      element: <ProductMixSummaryReport />,
      loader: productMixSummaryLoader,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Product Mix Summary Report"
            href="/reports/product-mix-summary-report"
          />
        ),
      },
    },
    {
      path: "cash-balance-report",
      id: "cash-balance-report",
      element: <CashBalanceReport />,
      loader: cashBalanceReportLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Cash Balance Loaded Report"
                href="/reports/cash-balance-report"
            />
        ),
      },
    },
    {
      path: "promo-balance-report",
      id: "promo-balance-report",
      element: <PromoBalanceReport />,
      loader: promoBalanceReportLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Promo Balance Loaded Report"
                href="/reports/promo-balance-report"
            />
        ),
      },
    },
    {
      path: "vendor-report",
      id: "vendor-report",
      element: <VendorSalesReport />,
      loader: vendorSalesLoader,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Vendor Sales Report"
            href="/reports/vendor-report"
          />
        ),
      },
    },
    {
      path: "vendor-type-report",
      id: "vendor-type-report",
      element: <VendorTypeSalesReport />,
      loader: vendorTypeSalesLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Vendor Type Sales Report"
                href="/reports/vendor-type-report"
            />
        ),
      },
    },
    {
      path: "event-summary-report",
      id: "event-summary-report",
      element: <EventSummaryReport />,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Event Summary Report"
                href="/reports/event-summary-report"
            />
        ),
      },
    },
    {
      path: "vertical-sales-report",
      id: "vertical-sales-report",
      element: <VerticalSalesReport />,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Vertical Sales Report"
                href="/reports/vertical-sales-report"
            />
        ),
      },
    },
    {
      path: "vendor-payouts",
      id: "vendor-payouts",
      element: <VendorPayouts />,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Vendor Payouts"
                href="/reports/vendor-payouts"
            />
        ),
      },
    },
    {
      path: "web-checkout-report",
      id: "web-checkout-report",
      element: <WebCheckoutReport />,
      // loader: transactionsLoader,
      handle: {
        crumb: () => (
            <Breadcrumb name="Web Checkout Report" href="/reports/web-checkout-report" />
        ),
      },
    },
    {
      path: "commissary-report",
      id: "commissary-report",
      element: <CommissaryReport />,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Commissary Report"
            href="/reports/commissary-report"
          />
        ),
      },
    },
    {
      path: "mx-merchant-reconciliation",
      id: "mx-merchant-reconciliation",
      element: <MXMerchantReconciliation />,
      loader: requireRoninAdmin(),
      errorElement: <ErrorBoundary />,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Reconciliation"
            href="/reports/mx-merchant-reconciliation"
          />
        ),
      },
    },
    {
      path: "gl-account-report",
      id: "gl-account-report",
      element: <GLAccountReport />,
      loader: glAccountLoader,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="GL Account Report"
                href="/reports/gl-account-report"
            />
        ),
      },
    },
    {
      path: "attendee-demographics-report",
      id: "attendee-demographics-report",
      element: <AttendeeDemographicsReport />,
      loader: requireAuth([PERMISSIONS.ADMIN]),
      errorElement: <ErrorBoundary />,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Attendee Demographics Report"
                href="/reports/attendee-demographics-report"
            />
        ),
      },
    },
    {
      path: "admin-app-usage",
      id: "admin-app-usage",
      element: <AdminAppUsageReport />,
      loader: requireRoninAdmin(),
      errorElement: <ErrorBoundary />,
      handle: {
        crumb: () => (
            <Breadcrumb
                name="Admin app usage"
                href="/reports/admin-app-usage"
            />
        ),
      },
    },
  ],
};
